export interface AccountLike {
  id?: string
}

/**
 * Pick the account the customer detail screen should show: the requested one when it belongs to this
 * customer, else the customer's first, else `null`. Tolerates a missing or non-array `accounts`.
 * Returns `null`, never `undefined` — a miss must not flip `v-if="account"` and hide every payment
 * action. Only call this where the customer is loaded: `currentAccount` is shared state that can name
 * another customer's account (ui-merchant#481).
 */
export function selectAccountForCustomer<T extends AccountLike>(
  customer: { accounts?: T[] | null } | null | undefined,
  preferredAccountID?: string | null
): T | null {
  const accounts = customer?.accounts

  if (!Array.isArray(accounts)) {
    return null
  }

  const preferred = preferredAccountID
    ? accounts.find(account => account?.id === preferredAccountID)
    : undefined

  return preferred ?? accounts[0] ?? null
}
